const ONETRUST_CATEGORIES_ENUM = {
	C0001: 'necessary_cookies',
	C0002: 'performance_cookies',
	C0003: 'functional_cookies',
	C0004: 'targeting_cookies'
}

export default {
	namespaced: true,
	state: {
		inited: false,
		/**
		 * OneTrust selected categories. Actual list is in the `window.OnetrustActiveGroups` variable.
		 * @type {Array<string>}
		 */
		activeGroups: [],
		/**
		 * Flag to indicate if user has closed OneTrust banner. The copy of `OneTrust.IsAlertBoxClosed()`.
		 * @type {Boolean}
		 */
		bannerClosed: false,
		/**
		 * Flag about necessity to interact with cookies popup.
		 */
		optInModel: false
	},
	getters: {
		getActiveGroups(state) {
			return state.activeGroups.map((group) => ONETRUST_CATEGORIES_ENUM[group] || group)
		},

		/**
		 * Check if we can hide OneTrust banner automatically.
		 * @param state
		 * @returns {boolean}
		 */
		isBannerAutoClosable(state) {
			return state.inited && !state.bannerClosed && !state.optInModel
		}
	},
	mutations: {
		setInited(state, inited) {
			state.inited = inited
		},
		setActiveGroups(state, activeGroups) {
			state.activeGroups = activeGroups
		},
		setBannerClosed(state, bannerClosed) {
			state.bannerClosed = bannerClosed
		},
		setOptInModel(state, optInModel) {
			state.optInModel = optInModel
		}
	}
}
